export default {
  autoBCC: state => {
    return state.autoBCC
  },
  running: state => {
    return state.running
  },
  user: state => {
    let user = {
      name: state.userName,
      email: state.userEmail,
      agentToken: state.userAgentToken,
    }
    return user
  },
  artifacts: state => {
    return state.artifacts
  },
  activity: state => {
    return state.activity
  },
  activityDate: state => {
    return state.activityDate
  },
  devMode: state => {
    return state.devMode
  },
  devServer: state => {
    return state.devServer
  },
  bccEmails: state => {
    return state.bccEmails
  },
  bccWhenRecipientInEmails: state => {
    return state.bccWhenRecipientInEmails
  },
  dontBccWhenRecipientInEmails: state => {
    return state.dontBccWhenRecipientInEmails
  },
  subjectOptimize: state => {
    return state.subjectOptimize
  },
}
